import React from 'react';
import { Chip } from '@mui/material';
import { TASK_STATUS } from './taskModels';

const TaskStatusChip = ({ status }) => {
  const statusProps = {
    [TASK_STATUS.DONE]: { color: 'success', label: 'Done' },
    [TASK_STATUS.ACTIVE]: { color: 'warning', label: 'Active' },
    [TASK_STATUS.NEW]: { color: 'error', label: 'New' },
  }[status];

  return (
    <Chip
      size="small"
      {...statusProps}
      sx={{ minWidth: 100, fontWeight: 500 }}
    />
  );
};

export default TaskStatusChip; 